import { useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { productsFiles } from "./productFile";
import "./ProductDetails.css";

export default function ProductDetail() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [activeImage, setActiveImage] = useState(0);

  const relatedProducts = useMemo(() => {
    if (!state) return [];
    return productsFiles
      .filter((p) => p.category === state.category && p.id !== state.id)
      .slice(0, 4);
  }, [state]);

  if (!state) {
    return (
      <div className="product-detail">
        <div className="container">
          <div className="not-found">
            <div className="not-found-icon">🔍</div>
            <h2>Product Not Found</h2>
            <p>The product you're looking for doesn't exist or has been removed.</p>
            <button className="btn btn-primary btn-lg" onClick={() => navigate("/products")}>
              Browse All Products
            </button>
          </div>
        </div>
      </div>
    );
  }

  const images = [state.imageL, state.image, state.imageR].filter(Boolean);

  return (
    <div className="product-detail">
      <div className="products-hero-sm">
        <div className="container">
          <nav className="breadcrumb">
            <button onClick={() => navigate("/")}>Home</button>
            <span>/</span>
            <button onClick={() => navigate("/products")}>Products</button>
            <span>/</span>
            <span className="current">{state.name}</span>
          </nav>
          <div className="hero-header">
            <div>
              <h1>{state.name}</h1>
              <span className="category-tag">{state.category}</span>
            </div>
            <button className="back-btn" onClick={() => navigate(-1)}>
              ← Back
            </button>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="detail-layout">
          <div className="detail-gallery">
            <div className="main-image-wrapper">
              <img
                src={images[activeImage]}
                alt={state.name}
                className="main-product-image"
              />
            </div>
            {images.length > 1 && (
              <div className="thumbnail-list">
                {images.map((img, idx) => (
                  <button
                    key={idx}
                    className={`thumbnail ${activeImage === idx ? "active" : ""}`}
                    onClick={() => setActiveImage(idx)}
                  >
                    <img src={img} alt={`${state.name} view ${idx + 1}`} />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="detail-sidebar">
            <div className="sidebar-card">
              <h3>Product Information</h3>

              <div className="info-row">
                <span className="info-label">Product Name</span>
                <span className="info-value">{state.name}</span>
              </div>

              <div className="info-row">
                <span className="info-label">Category</span>
                <span className="info-value category-badge">{state.category}</span>
              </div>

              <div className="info-row full-width">
                <span className="info-label">Composition</span>
                <span className="info-value composition-value">{state.composition}</span>
              </div>
            </div>

            <div className="sidebar-card description-card">
              <h3>Description</h3>
              <p>{state.description}</p>
            </div>

            <div className="sidebar-actions">
              <button className="btn btn-primary btn-lg" onClick={() => navigate("/contact")}>
                Enquire Now
              </button>
              <button className="btn btn-secondary" onClick={() => navigate("/products")}>
                Browse More
              </button>
            </div>
          </div>
        </div>

        {relatedProducts.length > 0 && (
          <section className="related-section">
            <h2>Related Products</h2>
            <p className="section-subtitle">You may also be interested in these products</p>
            <div className="related-grid">
              {relatedProducts.map((item) => (
                <div
                  className="related-card"
                  key={item.id}
                  onClick={() => {
                    setActiveImage(0);
                    navigate(`/product/${item.id}`, { state: item });
                  }}
                >
                  <div className="related-image">
                    <img src={item.image} alt={item.name} loading="lazy" />
                  </div>
                  <div className="related-content">
                    <span className="category-tag">{item.category}</span>
                    <h4>{item.name}</h4>
                    <p className="related-composition">{item.composition}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
